import { ActionTypes } from './constants';
import * as Models from './models';

export const refreshProject: Models.ActionCreator.RefreshProject = () => ({
  type: ActionTypes.REFRESH_PROJECT,
});
